import { Chip, Typography } from '@mui/material'

export default function StatusPill({
    label,
    variant = 'primary'
}: {
    label: string
    variant?: 'primary' | 'info' | 'success' | 'warning'
}) {
    return (
        <Chip
            color={variant}
            label={<Typography variant={'overline'}>{label}</Typography>}
        />
    )
}
